<template>
  <div class="layout-shell">
    <aside class="layout-aside">
      <div class="layout-brand">
        <div class="layout-brand-title">供应商后台</div>
        <div class="layout-brand-subtitle">CoRecogN Vendor Center</div>
      </div>
      <el-menu
        background-color="#1f2d3d"
        text-color="#fff"
        active-text-color="#409EFF"
        :default-active="$route.path"
        router
      >
        <el-menu-item index="/vendor/profile">供应商信息</el-menu-item>
        <el-menu-item index="/vendor/card">我的名片</el-menu-item>
        <el-menu-item index="/vendor/segments">号段信息</el-menu-item>
        <el-menu-item index="/vendor/create">创建 SN</el-menu-item>
        <el-menu-item index="/vendor/sns">我的 SN</el-menu-item>
      </el-menu>
    </aside>
    <main class="layout-main">
      <div class="layout-header">
        <div>
          <div class="layout-header-title">供应商工作台</div>
          <div class="layout-header-meta">管理号段、创建 SN 与查看签发记录</div>
        </div>
        <div class="layout-header-actions">
          <span>欢迎，{{ name }}</span>
          <el-button @click="logout">退出登录</el-button>
        </div>
      </div>
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  computed: {
    name() {
      return localStorage.getItem('name') || '供应商'
    },
  },
  methods: {
    logout() {
      localStorage.clear()
      this.$router.replace('/login')
    },
  },
}
</script>
